import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/arrow-right.svg'


const _hoisted_1 = { class: "entity-title entity-category-title" }
const _hoisted_2 = { id: "entity-categories" }
const _hoisted_3 = {
  class: "entity-btns-section",
  "aria-labelledby": 'entity-categories'
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-right",
  src: _imports_0,
  alt: "Right arrow"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("CategorySelection.filter_by_category")), 1)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityCategories, (category, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "entity-btn entity-category-btn",
            onClick: ($event: any) => (_ctx.categorySelected(category, index))
          }, [
            _createTextVNode(_toDisplayString(category) + " ", 1),
            _hoisted_5
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}